import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subscriber } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from "./api.service";
import { ResponseI } from './ResponseI';
import { oUser } from 'src/app/modals/user';
import { environment } from 'src/environments/environment';
import { AppConfigService } from 'src/app/app.config.service';

@Injectable({
    providedIn: 'root'
  })

export class AccountService  extends ApiService {

  private currentUserSubject: BehaviorSubject<oUser> = new BehaviorSubject({} as oUser);
  public readonly user: Observable<oUser> = this.currentUserSubject.asObservable();


  
    constructor(private httpClient: HttpClient) {
        super(httpClient);
    
    }

    setCurrentUser(currentUser: oUser): void {
      this.currentUserSubject.next(currentUser);
    }

    public changuePassword(pass: string, passnew:string): Observable<ResponseI> {

      let headers = this._headers;
      let params = new FormData();
      params.append('pass', pass);
      params.append('passnew', passnew);
      const options = {  headers: headers };
      return this._httpcli.post<ResponseI>(this.URL_SERVER + "changepassword", params, options );
  
  }

    public login(usuario: string, pass:string): Observable<ResponseI> {

        let headers = this._headers;
        let params = new FormData();
        params.append('usuario', usuario);
        params.append('pass', pass);
        params.append('MODO', AppConfigService.config.MODE);
        const options = {  headers: headers };
        return this._httpcli.post<ResponseI>(this.URL_SERVER + "login", params, options );
    

    }

    public sendAccount(usuario: string, pass:string): Observable<ResponseI> {

      let headers = this._headers;
      let params = new FormData();
      params.append('nrousuario', usuario);
      params.append('usumail', pass);
      const options = {  headers: headers };
      return this._httpcli.post<ResponseI>(this.URL_SERVER + "getaccount", params, options );
  
    }

    public getdeuda(): Observable<ResponseI> {

      let headers = this._headers;
      let params = new FormData();
      const options = {  headers: headers };
      return this._httpcli.post<ResponseI>(this.URL_SERVER + "getdeuda", params, options );
  

    }

    public getmydata(): Observable<ResponseI> {

      let headers = this._headers;
      let params = new FormData();
      const options = {  headers: headers };
      return this._httpcli.post<ResponseI>(this.URL_SERVER + "getmydata", params, options );
  

    }

    public getAccount():oUser{
      return JSON.parse(localStorage.getItem("user")) || undefined;
    }
    public storeAccount(user){
      localStorage.setItem("user", JSON.stringify(user));
    }
    public logout(){
      localStorage.removeItem("user");
    }


    public createAccount(name:string,
                         address:string,
                         ciudad:string,
                         state:string,
                         postcode:string,
                         email:string,
                         phone:string,
                         nota:string,
                         pass:string,
                         username:string): Observable<ResponseI> {

      let headers = this._headers;
      let params = new FormData();
      params.append('name', name);
      params.append('address', address);
      params.append('ciudad', ciudad);
      params.append('state', state);
      params.append('postcode', postcode);
      params.append('email', email);
      params.append('phone', phone);
      params.append('nota', nota);
      params.append('pass', pass);
      params.append('username', username);                  
      const options = {  headers: headers };
      return this._httpcli.post<ResponseI>(this.URL_SERVER + "addeditaccount", params, options );
  
    }


}    